
// Informations
//     InfoPerson
//     InfoArticle
//     InfoReply 





import InfoPerson from './InfoPerson';
import InfoArticle from './InfoArticle';
import InfoReplies from './InfoReplies';


export default props=>{
    if (!props.me) return <></>;
    // console.log("props.me: ", props.me);

    return (<div className="informations-js">
        <style jsx>{`
.left-right{
    text-align:right;
    padding: 40px 0;
}
`}</style>

        <InfoPerson me={props.me} likePlus={props.likePlus}/>
        <div>&nbsp;</div>
        <div>&nbsp;</div>
        <InfoArticle me={props.me} />
        <div className="dbom left-right">
            <img onClick={props.moveLeft} src="/assets/images-m/group-4.svg" />
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <img onClick={props.moveRight} src="/assets/images-m/group-5-2222.svg" />
        </div>

        <InfoReplies me={props.me} />

    </div>);
}